/* eslint-disable @typescript-eslint/no-unused-vars */

export const cellStyle = ({ palette = {} }) => ({
  '& .flex-cell': {
    fontSize: 12,
    width: 120,
    flexGrow: 0,
    wordWrap: 'break-word',
    wordBreak: 'break-word',

    '&.text-right': {
      justifyContent: 'flex-end',
      '& .grid-editable-cell-container': {
        justifyContent: 'flex-end',
      },
    },
    '&.text-left': {
      justifyContent: 'flex-start',
    },
    '&.text-center': {
      justifyContent: 'center',
    },

    // editable cell
    '& .grid-editable-cell-container': {
      display: 'flex',
      width: '100%',
      justifyContent: 'space-between',
      alignItems: 'center',
      '& .grid-edit-icon': {
        opacity: 0,
      },
    },

    // make sure the grid header cover the icon
    '& .iconba, .helpbutton:before, .grid-edit-icon': {
      position: 'static',
    },
  },
});
